export default __webpack_public_path__ + "static/media/home9.76ebe508.jpg";